import { Injectable } from '@angular/core';
import { TabSheetComponent } from 'src/app/shared/content/tab-sheet/tab-sheet.component';

@Injectable()
export class TabSheetsService {
  private readonly tabSheets = new Array<TabSheetComponent>();

  public get components(): any[] {
    return this.tabSheets.flatMap((x) => x.tabs.map((y) => y.getComponent?.())).filter((x) => x);
  }

  public add(tabSheet: TabSheetComponent): void {
    this.tabSheets.push(tabSheet);
  }

  public remove(tabSheet: TabSheetComponent): void {
    this.tabSheets.splice(this.tabSheets.indexOf(tabSheet), 1);
  }
}
